// Options for the "Área Propícia por:" projection dropdown (StatisticsPanel), and the
// single source of truth for which GeoServer layer names belong to that dropdown.
// Keeping this in one place avoids the two lists drifting apart (e.g. a stale layer
// name, or eólico layers missing from a "clear all projections" list) when a projection
// layer is renamed or added.

export const PROJECTION_LAYER_OPTIONS = [
  { label: "Teórico", layerName: "pepe-cog:potencial_teorico_solar" },
  { label: "Geográfico", layerName: "pepe-cog:potencial_geografico_solar_PE" },
  { label: "Técnico", layerName: "pepe-cog:potencial_tecnico_solar_PE" },
  { label: "Econômico I", layerName: "pepe-cog:potencial_economico1_solar_PE" },
  { label: "Econômico II", layerName: "pepe-cog:potencial_economico2_solar_PE" },
  { label: "Econômico III", layerName: "pepe-cog:potencial_economico3_solar_PE" },
] as const;

export const EOLICO_PROJECTION_LAYER_OPTIONS = [
  { label: "Teórico", layerName: "pepe-cog:potencial_teorico_eolico" },
  { label: "Geográfico", layerName: "pepe-cog:potencial_geografico_eolico_PE" },
  { label: "Econômico I", layerName: "pepe-cog:potencial_economico1_eolico_PE" },
] as const;

export const ALL_PROJECTION_LAYERS: string[] = [
  ...PROJECTION_LAYER_OPTIONS.map((p) => p.layerName),
  ...EOLICO_PROJECTION_LAYER_OPTIONS.map((p) => p.layerName),
];

// The 3 projection types offered when generating a report — a subset of the options
// above common to both solar and eólico (report doesn't expose "Técnico"/"Econômico II").
export const REPORT_PROJECTION_TYPES = [
  { value: "teorico", label: "Teórico" },
  { value: "geografico", label: "Geográfico" },
  { value: "economico1", label: "Econômico I" },
] as const;

export type ReportProjectionType =
  (typeof REPORT_PROJECTION_TYPES)[number]["value"];

function pickLayer(
  options: readonly { label: string; layerName: string }[],
  label: string
): string {
  const match = options.find((o) => o.label === label);
  if (!match) throw new Error(`Projection layer not found for label "${label}"`);
  return match.layerName;
}

export const REPORT_PROJECTION_SOLAR_LAYER: Record<ReportProjectionType, string> =
  {
    teorico: pickLayer(PROJECTION_LAYER_OPTIONS, "Teórico"),
    geografico: pickLayer(PROJECTION_LAYER_OPTIONS, "Geográfico"),
    economico1: pickLayer(PROJECTION_LAYER_OPTIONS, "Econômico I"),
  };

export const REPORT_PROJECTION_EOLICO_LAYER: Record<ReportProjectionType, string> =
  {
    teorico: pickLayer(EOLICO_PROJECTION_LAYER_OPTIONS, "Teórico"),
    geografico: pickLayer(EOLICO_PROJECTION_LAYER_OPTIONS, "Geográfico"),
    economico1: pickLayer(EOLICO_PROJECTION_LAYER_OPTIONS, "Econômico I"),
  };
